module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-BlackItalic.1193076.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceSansPro-BlackItalic.ttf
// module id = 17fH
// module chunks = 1